module.exports = __webpack_public_path__ + "static/media/add_agent.fcfa45f1.svg";